import { useEffect, useMemo, useState, useCallback } from 'react'
import "./style.css"
import { ReactComponent as SmallScreenLeftArrow } from "../../Assets/icon/arrow-narrow-left-white.svg";
import { ReactComponent as LeftArrow } from "../../Assets/icon/arrow-narrow-left.svg";
import { ReactComponent as CloseIcon } from "../../Assets/icon/close.svg";
import ReactMarkdown from "react-markdown";
import { useHeader } from '../../Providers/HeaderContextProvider';
import { useNavigate } from 'react-router-dom';
import { getSessionHistory, deleteConversation, searchChatSessions, renameConversationTitle } from '../../Services/Chat';
import { getResumableConversations } from '../../Services/coaching';
import { dialogueDestinations } from '../Explore/launch';
import ContentLoader from '../LoadingPage/ContentLoader';
import dotVertical from "../../Assets/images/dots-vertical.svg";
import trash from "../../Assets/images/TrashRed.svg";
import editIcon from "../../Assets/images/edit.svg";
import searchIcon from "../../Assets/images/searchIcon.png";
import GenericModal from '../../Components/Modal/GenericModal';
import { showSuccessToast, showErrorToast } from '../../Utils/toast';

const ChatIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M6.66732 9.99992L4.61715 12.0757C4.33117 12.3653 4.18819 12.51 4.06529 12.5202C3.95866 12.5291 3.85426 12.4862 3.78462 12.405C3.70435 12.3114 3.70435 12.1079 3.70435 11.7009V10.661C3.70435 10.2959 3.40537 10.0317 3.04412 9.9788C2.16981 9.85073 1.48317 9.16409 1.3551 8.28978C1.33398 8.14562 1.33398 7.9736 1.33398 7.62955V4.53325C1.33398 3.41315 1.33398 2.85309 1.55197 2.42527C1.74372 2.04895 2.04968 1.74299 2.426 1.55124C2.85383 1.33325 3.41388 1.33325 4.53398 1.33325H9.46732C10.5874 1.33325 11.1475 1.33325 11.5753 1.55124C11.9516 1.74299 12.2576 2.04895 12.4493 2.42527C12.6673 2.85309 12.6673 3.41315 12.6673 4.53325V7.33325M12.6673 14.6666L11.2164 13.6578C11.0124 13.516 10.9104 13.4451 10.7995 13.3949C10.7009 13.3503 10.5974 13.3178 10.491 13.2982C10.3712 13.2761 10.247 13.2761 9.9986 13.2761H8.80065C8.05391 13.2761 7.68055 13.2761 7.39533 13.1308C7.14445 13.003 6.94047 12.799 6.81264 12.5481C6.66732 12.2629 6.66732 11.8895 6.66732 11.1428V9.46659C6.66732 8.71985 6.66732 8.34648 6.81264 8.06126C6.94047 7.81038 7.14445 7.60641 7.39533 7.47858C7.68055 7.33325 8.05391 7.33325 8.80065 7.33325H12.534C13.2807 7.33325 13.6541 7.33325 13.9393 7.47858C14.1902 7.60641 14.3942 7.81038 14.522 8.06126C14.6673 8.34648 14.6673 8.71985 14.6673 9.46658V11.2761C14.6673 11.8974 14.6673 12.208 14.5658 12.453C14.4305 12.7797 14.1709 13.0393 13.8442 13.1746C13.5992 13.2761 13.2886 13.2761 12.6673 13.2761V14.6666Z" stroke="black" strokeWidth="0.666667" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

const VoiceIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="none">
        <path d="M6.66699 0C7.12695 0.000188829 7.49984 0.373039 7.5 0.833008V11.5088C7.5 11.9689 7.12706 12.3426 6.66699 12.3428C6.20677 12.3428 5.83301 11.969 5.83301 11.5088V0.833008C5.83317 0.372922 6.20687 0 6.66699 0ZM3.75 2.55371C4.21021 2.55372 4.58301 2.92748 4.58301 3.3877V8.95605C4.58299 9.41625 4.2102 9.78905 3.75 9.78906C3.28979 9.78906 2.91701 9.41626 2.91699 8.95605V3.3877C2.91699 2.92747 3.28978 2.55371 3.75 2.55371ZM9.58105 2.55371C10.0412 2.55377 10.4141 2.92751 10.4141 3.3877V8.95605C10.414 9.41622 10.0412 9.789 9.58105 9.78906C9.12084 9.78906 8.74807 9.41626 8.74805 8.95605V3.3877C8.74805 2.92747 9.12083 2.55371 9.58105 2.55371ZM0.833008 4.25586C1.29323 4.25586 1.66699 4.62962 1.66699 5.08984V7.67871C1.66699 8.13893 1.29323 8.5127 0.833008 8.5127C0.372922 8.51253 0 8.13883 0 7.67871V5.08984C0 4.62972 0.372922 4.25602 0.833008 4.25586ZM12.5 3.79785C12.9601 3.79786 13.3328 4.17079 13.333 4.63086V7.2207C13.3329 7.68084 12.9602 8.0537 12.5 8.05371C12.0398 8.05371 11.6671 7.68085 11.667 7.2207V4.63086C11.6672 4.17078 12.0399 3.79785 12.5 3.79785Z" fill="black"/>
    </svg>
);

// A Dialogue is one row (`type: "dialogue"`) across all its visits and calls.
const isDialogueRow = (item) => item?.type === 'dialogue';

// A Dialogue active across a page boundary can appear twice; keep the first
// (newest) row per instance_id.
const dedupeDialogueRows = (groups) => {
    const seen = new Set();
    const out = {};
    Object.keys(groups || {}).forEach((key) => {
        out[key] = (groups[key] || []).filter((item) => {
            if (!isDialogueRow(item) || !item.instance_id) return true;
            if (seen.has(item.instance_id)) return false;
            seen.add(item.instance_id);
            return true;
        });
    });
    return out;
};

const CoachingHistory = () => {
    const { setHeaderContent } = useHeader();
    const navigate = useNavigate();

    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

    // State management
    const [groupedData, setGroupedData] = useState({});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [search, setSearch] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [isSearching, setIsSearching] = useState(false);
    const [menuFor, setMenuFor] = useState(null);
    const [actionLoading, setActionLoading] = useState(false);

    // Set of conversation_ids that can be resumed (individual voice only).
    // Sourced from the dedicated recent-conversations endpoint so we only ever
    // offer Resume for ids the backend recognizes as resumable.
    const [resumableIds, setResumableIds] = useState(() => new Set());

    // Modal states
    const [deleteModal, setDeleteModal] = useState({ open: false, item: null });
    const [renameModal, setRenameModal] = useState({ open: false, item: null, title: '' });
    const [summaryModal, setSummaryModal] = useState({ open: false, item: null });

    // Set header content   
    useEffect(() => {
        setHeaderContent(false);
    }, [setHeaderContent]);

    useEffect(() => {
        const handleResize = () => setScreenWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Close menu on document click
    useEffect(() => {
        const onDocClick = () => setMenuFor(null);
        document.addEventListener('click', onDocClick);
        return () => document.removeEventListener('click', onDocClick);
    }, []);

    // Load session history data
    useEffect(() => {
        let mounted = true;
        const loadData = async () => {
            setLoading(true);
            setError(null);
            try {
                const response = await getSessionHistory(30, true, true, true);
                
                if (!mounted) return;

                if (response?.payload?.data) {
                    setGroupedData(dedupeDialogueRows(response.payload.data));
                } else {
                    setGroupedData({});
                }
            } catch (err) {
                if (!mounted) return;
                console.error(err);
                setError(err?.message || "Failed to load data");
            } finally {
                if (!mounted) return;
                setLoading(false);
            }
        };

        loadData();
        return () => { mounted = false; };
    }, []);

    // Load the set of resumable individual-voice conversation ids.
    useEffect(() => {
        let mounted = true;
        getResumableConversations(30)
            .then((res) => {
                if (!mounted) return;
                const ids = (res?.conversations || [])
                    .map((c) => c?.conversation_id)
                    .filter(Boolean);
                setResumableIds(new Set(ids));
            })
            .catch((err) => {
                // Non-fatal: history still renders, just without Resume buttons.
                console.error('Failed to load resumable conversations:', err);
            });
        return () => { mounted = false; };
    }, []);



    // Debounced unified search
    useEffect(() => {
        const timeoutId = setTimeout(async () => {
            if (search.trim()) {
                setIsSearching(true);
                try {
                    const response = await searchChatSessions(search.trim(), 20, 0);
                    setSearchResults(response?.data || []);
                } catch (err) {
                    console.error('Search error:', err);
                    setSearchResults([]);
                } finally {
                    setIsSearching(false);
                }
            } else {
                setSearchResults([]);
                setIsSearching(false);
            }
        }, 300);

        return () => clearTimeout(timeoutId);
    }, [search]);

    // Get display data (search results or grouped data)
    const displayData = useMemo(() => {
        if (search.trim()) {
            const groups = {
                'Today': [],
                'Yesterday': [],
                'Previous 7 days': [],
                'Previous 30 days': [],
                'Older': []
            };

            const now = new Date();
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            const yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000);
            const sevenDaysAgo = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000);
            const thirtyDaysAgo = new Date(today.getTime() - 30 * 24 * 60 * 60 * 1000);

            searchResults.forEach(item => {
                const itemDate = new Date(item?.updated_at || item?.created_at || item?.timestamp || 0);

                if (itemDate >= today) {
                    groups['Today'].push(item);
                } else if (itemDate >= yesterday) {
                    groups['Yesterday'].push(item);
                } else if (itemDate >= sevenDaysAgo) {
                    groups['Previous 7 days'].push(item);
                } else if (itemDate >= thirtyDaysAgo) {
                    groups['Previous 30 days'].push(item);
                } else {
                    groups['Older'].push(item);
                }
            });

            return groups;
        }
        return groupedData;
    }, [groupedData, searchResults, search]);

    // Delete handler
    const handleDelete = async (item) => {
        const id = item?.session_id || item?.conversation_id;
        if (!id) return;

        setActionLoading(true);
        try {
            await deleteConversation(id);
            // Remove from local state
            const removeFromGroups = (groups) => {
                const newGroups = {};
                Object.keys(groups).forEach(key => {
                    newGroups[key] = (groups[key] || []).filter(it => 
                        (it.session_id || it.conversation_id) !== id
                    );
                });
                return newGroups;
            };
            setGroupedData(prev => removeFromGroups(prev));
            setSearchResults(prev => prev.filter(it => (it.session_id || it.conversation_id) !== id));
            showSuccessToast('Session deleted');
        } catch (e) {
            console.error('Delete error:', e);
            showErrorToast(e?.message || 'Failed to delete');
        } finally {
            setActionLoading(false);
        }
    };

    // Returns the resumable conversation_id for an item, or null if it can't be
    // resumed. An item is resumable only when its id is present in the recent
    // conversations set (individual voice owned by the user).
    const getResumableId = (item) => {
        if (!item) return null;
        const candidates = [item.conversation_id, item.session_id].filter(Boolean);
        return candidates.find((id) => resumableIds.has(id)) || null;
    };

    // Resume a previous individual voice conversation: open the voice coach with
    // resume_conversation_id so Aris greets "welcome back" and carries context.
    const handleResume = (item) => {
        const id = getResumableId(item);
        if (!id) return;
        navigate(`/coach/private?resume_conversation_id=${encodeURIComponent(id)}`);
    };

    // Open session from title click
    const handleOpenSession = (item) => {
        // A Dialogue row opens the Dialogue itself (its full history), not
        // one conversation.
        if (isDialogueRow(item)) {
            const routes = dialogueDestinations({ instanceId: item.instance_id });
            if (routes) navigate(routes.text);
            return;
        }
        const isVoice = item?.type === 'voice' || ['VOICE', 'VOICE_COUPLE', 'VOICE_GROUP'].includes(item?.module);
        
        if (isVoice) {
            setSummaryModal({ open: true, item });
        } else {
            const sessionId = item?.session_id || item?.conversation_id;
            if (!sessionId) return;
            const module = item?.module || 'COACHING';
            navigate(`/chat?sessionId=${encodeURIComponent(sessionId)}&module=${encodeURIComponent(module)}`);
        }
    };

    // Rename handler
    const handleRename = async (item, newTitle) => {
        const id = item?.session_id || item?.conversation_id;
        if (!id || !newTitle.trim()) return;

        setActionLoading(true);
        try {
            await renameConversationTitle(id, newTitle.trim());
            // Update local state
            const updateInGroups = (groups) => {
                const newGroups = {};
                Object.keys(groups).forEach(key => {
                    newGroups[key] = (groups[key] || []).map(it =>
                        (it.session_id || it.conversation_id) === id
                            ? { ...it, title: newTitle.trim() }
                            : it
                    );
                });
                return newGroups;
            };
            setGroupedData(prev => updateInGroups(prev));
            setSearchResults(prev => prev.map(it =>
                (it.session_id || it.conversation_id) === id
                    ? { ...it, title: newTitle.trim() }
                    : it
            ));
            showSuccessToast('Session renamed');
        } catch (e) {
            console.error('Rename error:', e);
            showErrorToast(e?.message || 'Failed to rename');
        } finally {
            setActionLoading(false);
        }
    };

    return (
        <div className='coaching-history-container'>
            {/* Header */}
            <header className="termsofuse-header">
                <div className="termsofuse-gradient-background">
                    <div className="termsofuse-nav-container">
                        <div className="termsofuse-logo-container" onClick={() => navigate("/dashboard")}>
                            {screenWidth < 480 && (
                                <SmallScreenLeftArrow className="termsofuse-back-button" />
                            )}
                            {screenWidth >= 480 && (
                                <LeftArrow className="termsofuse-back-button" />
                            )}
                        </div>

                        <h1 className="head-not-txt">Coaching History</h1>
                        <div className="termsofuse-space"></div>
                    </div>
                </div>
            </header>
            {/* Main Content */}
            <div className="coaching-history-main">
                <div className="coaching-history-content">
                    {/* Content Header */}
                    <div className="coaching-history-content-header">
                        <div className="coaching-history-content-info">
                            <h2 className="coaching-history-content-title">Session History</h2>
                            <p className="coaching-history-content-subtitle">
                                Track your progress and reflect on your journey
                            </p>
                        </div>

                        {/* Search */}
                        <div className={`coaching-history-search ${search.trim() ? 'has-value' : ''}`}>
                            <div className="coaching-history-search-field">
                                <div className="coaching-history-search-icon">
                                    <img src={searchIcon} alt="Search" />
                                </div>
                                <input
                                    type="text"
                                    className="coaching-history-search-input"
                                    placeholder="Search..."
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                />
                                <button
                                    type="button"
                                    className="coaching-history-clear-btn"
                                    onClick={() => setSearch("")}
                                    aria-label="Clear search"
                                >
                                    <CloseIcon />
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Content */}
                    {loading && <div className="coaching-history-loading"><ContentLoader /></div>}
                    {error && <div className="coaching-history-error">{String(error)}</div>}

                    {isSearching && !loading && !error && (
                        <div className="coaching-history-loading"><ContentLoader /></div>
                    )}

                    {!loading && !error && !isSearching && (
                        Object.keys(displayData).length === 0 || Object.values(displayData).every(arr => arr.length === 0) ? (
                            <div className="coaching-history-empty">
                                {search.trim() ? 'No results found' : 'No history found'}
                            </div>
                        ) : (
                            <div className="coaching-history-list">
                                {Object.entries(displayData).map(([period, items]) =>
                                    items && items.length > 0 && (
                                        <div key={period} className="coaching-history-group">
                                            <h3 className="coaching-history-group-title">{period}</h3>
                                            <div className="coaching-history-items">
                                                {items.map((item, idx) => (
                                                    <HistoryItem
                                                        key={item.instance_id || item.conversation_id || item.session_id || idx}
                                                        item={item}
                                                        canResume={!!getResumableId(item)}
                                                        onResume={() => handleResume(item)}
                                                        menuOpen={menuFor === `${period}-${idx}`}
                                                        onMenuToggle={() => setMenuFor(
                                                            menuFor === `${period}-${idx}` ? null : `${period}-${idx}`
                                                        )}
                                                        onOpen={() => handleOpenSession(item)}
                                                        onRename={() => {
                                                            setRenameModal({
                                                                open: true,
                                                                item,
                                                                title: item?.title || ''
                                                            });
                                                            setMenuFor(null);
                                                        }}
                                                        onDelete={() => {
                                                            setDeleteModal({ open: true, item });
                                                            setMenuFor(null);
                                                        }}
                                                    />
                                                ))}
                                            </div>
                                        </div>
                                    )
                                )}
                            </div>
                        )
                    )}
                </div>
            </div>

            {/* Rename Modal */}
            <GenericModal
                isOpen={renameModal.open}
                onClose={() => setRenameModal({ open: false, item: null, title: '' })}
                heading="Rename Session?"
                primaryLabel="Save"
                secondaryLabel="Cancel"
                onPrimary={async () => {
                    if (actionLoading) return;
                    setActionLoading(true);
                    try {
                        await handleRename(renameModal.item, renameModal.title);
                        setRenameModal({ open: false, item: null, title: '' });
                    } finally {
                        setActionLoading(false);
                    }
                }}
                onSecondary={() => setRenameModal({ open: false, item: null, title: '' })}
                maxWidth="400px"
            >
                {actionLoading ? (
                    <div className="coaching-history-rename-input-wrapper"><ContentLoader /></div>
                ) : (
                    <div className="coaching-history-rename-input-wrapper">
                        <input
                            type="text"
                            className="coaching-history-rename-input"
                            value={renameModal.title}
                            onChange={(e) => setRenameModal(prev => ({ ...prev, title: e.target.value }))}
                            placeholder="Enter new name"
                            autoFocus
                        />
                    </div>
                )}
            </GenericModal>

            {/* Delete Modal */}
            <GenericModal
                isOpen={deleteModal.open}
                onClose={() => setDeleteModal({ open: false, item: null })}
                heading="Delete Session?"
                primaryLabel="Delete"
                secondaryLabel="Cancel"
                primaryVariant="danger"
                onPrimary={async () => {
                    if (actionLoading) return;
                    setActionLoading(true);
                    try {
                        await handleDelete(deleteModal.item);
                        setDeleteModal({ open: false, item: null });
                    } finally {
                        setActionLoading(false);
                    }
                }}
                onSecondary={() => setDeleteModal({ open: false, item: null })}
                maxWidth="400px"
            >
                {actionLoading ? (
                    <div className="coaching-history-rename-input-wrapper"><ContentLoader /></div>
                ) : (
                    <div className="coaching-history-rename-input-wrapper">
                        <div>This will delete {deleteModal.item?.topic || deleteModal.item?.title || 'this session'}</div>
                    </div>
                )}
            </GenericModal>

            {/* Voice Summary Modal */}
            <GenericModal
                isOpen={summaryModal.open}
                onClose={() => setSummaryModal({ open: false, item: null })}
                heading={summaryModal.item?.title || 'Session Summary'}
                primaryLabel=""
                secondaryLabel=""
                maxWidth="600px"
            >
                <div className="coaching-history-summary-content">
                    {summaryModal.item?.timestamp && (
                        <div className="coaching-history-summary-meta">
                            {new Date(summaryModal.item.timestamp).toLocaleString(undefined, {
                                month: 'short',
                                day: '2-digit',
                                year: 'numeric',
                                hour: 'numeric',
                                minute: '2-digit',
                                hour12: true
                            })}
                            {summaryModal.item?.participants && Object.keys(summaryModal.item.participants).length > 0 && (
                                <span> | {Object.values(summaryModal.item.participants).join(', ')}</span>
                            )}
                        </div>
                    )}
                    <div className="coaching-history-summary-body">
                        <ReactMarkdown>{summaryModal.item?.summary || 'No summary available'}</ReactMarkdown>
                    </div>
                    {getResumableId(summaryModal.item) && (
                        <div className="coaching-history-summary-actions">
                            <button
                                type="button"
                                className="coaching-history-resume-btn"
                                onClick={() => handleResume(summaryModal.item)}
                            >
                                Resume conversation
                            </button>
                        </div>
                    )}
                </div>
            </GenericModal>
        </div>
    );
};

// History Item Component
const HistoryItem = ({ item, menuOpen, onMenuToggle, onRename, onDelete, onOpen, canResume, onResume }) => {
    const isVoice = item?.type === 'voice' || ['VOICE', 'VOICE_COUPLE', 'VOICE_GROUP'].includes(item?.module);
    const title = item?.title || 'Untitled Session';
    const timeValue = item?.timestamp;
    const timeString = (() => {
        if (!timeValue) return '';
        try {
            const d = new Date(timeValue);
            return d.toLocaleString(undefined, {
                month: 'short', day: '2-digit', year: 'numeric',
                hour: 'numeric', minute: '2-digit', hour12: true
            });
        } catch (_) { return String(timeValue); }
    })();
    const participantsObj = item?.participants || {};
    const participantNames = Object.values(participantsObj);
    const participantsLine = participantNames.join(', ');
    // Rename / delete act on one conversation's session id; a Dialogue row has none.
    const hasMenu = !isDialogueRow(item);

    return (
        <div className="coaching-history-item">
            <div className="coaching-history-item-icon">
                {isVoice ? <VoiceIcon /> : <ChatIcon />}
            </div>
            <div className="coaching-history-item-content">
                <div
                    className="coaching-history-item-title clickable"
                    onClick={onOpen}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            onOpen();
                        }
                    }}
                >
                    {title}
                </div>
                {(timeString || participantsLine) && (
                    <div className="coaching-history-item-meta">
                        {timeString && <span className="meta-time">{timeString}</span>}
                        {timeString && participantsLine && <span className="meta-sep">|</span>}
                        {participantsLine && <span className="meta-participants">{participantsLine}</span>}
                    </div>
                )}
            </div>

            <div className="coaching-history-item-actions">
                {canResume && (
                    <button
                        type="button"
                        className="coaching-history-resume-btn coaching-history-resume-btn-inline"
                        onClick={(e) => {
                            e.stopPropagation();
                            onResume();
                        }}
                    >
                        Resume
                    </button>
                )}
                {hasMenu && (
                    <button
                        className="coaching-history-item-menu-button"
                        onClick={(e) => {
                            e.stopPropagation();
                            onMenuToggle();
                        }}
                        aria-label="More options"
                    >
                        <img src={dotVertical} alt="menu" />
                    </button>
                )}

                {hasMenu && menuOpen && (
                    <div
                        className="coaching-history-item-menu"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div
                            className="coaching-history-item-menu-option"
                            onClick={onRename}
                        >
                            <img src={editIcon} alt="rename" />
                            Rename
                        </div>
                        <div
                            className="coaching-history-item-menu-option delete"
                            onClick={onDelete}
                        >
                            <img src={trash} alt="delete" />
                            Delete
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CoachingHistory